import { Trans, t } from '@lingui/macro'

import {
  Dialog,
  DialogContainer,
  DialogContent,
  DialogContextType,
  DialogDescription,
  DialogHeading,
  DialogXButton,
} from 'src/components/Dialog'

import ReleaseCartForm from 'src/forms/ReleaseCartForm'
import { openFailureToast, openSuccessToast } from 'src/lib/toast'

type ReleaseCartDialogContainerProps = {
  cart: any
  onClose: () => void
}

const ReleaseCartDialogContainer: React.FC<ReleaseCartDialogContainerProps> = ({
  cart,
  onClose,
}) => (
  <Dialog initialOpen onClose={onClose}>
    <DialogContainer>
      <DialogXButton />
      <DialogHeading>
        <Trans>Release cart</Trans>
      </DialogHeading>
      <DialogDescription>
        <Trans>
          You return the shopping cart "{cart.name}" to "
          {cart.originalCustomer?.email}"
        </Trans>
      </DialogDescription>
      <DialogContent>
        {
          ((context: DialogContextType) => {
            const dismiss = () => context.setOpen(false)
            return (
              <ReleaseCartForm
                cart={cart}
                onSuccess={() => {
                  openSuccessToast(t`Cart released successfully`)
                  dismiss()
                }}
                onError={() => {
                  openFailureToast(t`Cart could not be released`)
                  dismiss()
                }}
                onCancel={dismiss}
              />
            )
          }) as any
        }
      </DialogContent>
    </DialogContainer>
  </Dialog>
)

export default ReleaseCartDialogContainer
